module.exports = __webpack_public_path__ + "media/tw_wh2_dlc15_warden_theme.108b0d5d.webm";